<template>
   <div class="csvimport">
    <div class="panel panel-sm">
      <div class="panel-heading"> 
        <h4>Importar CSV</h4>
      </div>
      <div class="panel-body">
        <div class="row">
          <div class="form-group">
            <label for="csv_file" class="control-label col-xs-12">CSV para importação</label>
            <div class="col-xs-12">
              <input
                type="file"
                id="csv_file"
                name="csv_file"
                accept=".csv"
                class="form-control"
                @change="loadCSV($event)"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    separador: {
      type: String,
      default: ';'
    }
  },
  data() {
    return {
      channel_name: '',
      channel_fields: [],
      channel_entries: [],
      parse_header: [],
      parse_csv: [],
      sortOrders:{},
      sortKey: ''
    };
  },
  filters: {
    capitalize: function (str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    }
  },
  methods: {
    sortBy: function (key) {
      var vm = this
      vm.sortKey = key
      vm.sortOrders[key] = vm.sortOrders[key] * -1
    },
    csvJSON(csv){
      var vm = this
      var lines = csv.split(/\r\n|\n|\r/)
      var result = []
      var headers = lines[0].split(vm.separador)
      vm.parse_header = lines[0].split(vm.separador)
      lines[0].split(vm.separador).forEach(function (key) {
        vm.sortOrders[key] = 1
      })
      
      lines.map(function(line, indexLine){
        if (indexLine < 1) return // Jump header line
        
        var obj = {}
        var currentline = line.split(vm.separador)
        
        headers.map(function(header, indexHeader){
          obj[header] = currentline[indexHeader]
        })
        
        result.push(obj)
      })
      
      result.pop() // remove the last item because undefined values
      
      return result // JavaScript object
    },
    csvJSON2(csv) {
      // Nova Logica
      const { separador } = this
      // 1 - quebrar o CSV em linhas
      const lines = csv.split(/\r\n|\n|\r/)
      // 2 - obter os headers da primeira linha
      const headers = lines[0].split(separador)
      // 3 - obter o count dos headers
      const countHeaders = headers.length
      // 4 - splitar o CSV original com o separador e obter o count do separador
      const pattern = new RegExp(`${separador}|\r\n|\n|\r`)
      const csvSplit = csv.split(pattern)
      const countCSV = csvSplit.length
      // 5 - iniciar um for a partir do count do headers e fechar o for menor que o count do separador
      const itens = []
      for (let itemIndex = countHeaders; itemIndex < countCSV; itemIndex++) {
        // 6 - dentro do for iniciar outro for a partir do 0 e fechar menor que count do header
        const item = {}
        for (let valueIndex = 0; valueIndex < countHeaders; valueIndex++) {
          // 7 - dentro do for criar um indice que será a index for anterior + index do for atual
          const indice = itemIndex + valueIndex
          // 8 - uso o index desse for para obter o key e uso o indice criado com o CSV quebrado pelo separador para obter o value
          const key = headers[valueIndex]
          const value = csvSplit[indice]
          // 9 - adiciono esse key e value em um objeto
          item[key] = value
        }
        // 10 - fora do for adiciono o objeto dentro do array de resultados
        itens.push(item)
      }
      // 11 - ao finalizar o ultimo for retorno o array de resultados
      return itens
    },  
    loadCSV(e) {
      var vm = this
      if (window.FileReader) {
        var reader = new FileReader();
        const retorno = this.returnCSV
        reader.readAsText(e.target.files[0]);
        // Handle errors load
        reader.onload = function(event) {
          var csv = event.target.result;
          //vm.parse_csv = vm.csvJSON(csv)
          vm.parse_csv = vm.csvJSON(csv)
          retorno()
        };
        reader.onerror = function(evt) {
          if(evt.target.error.name == "NotReadableError") {
            alert("Não foi possível ler o arquivo!");
          }
        };
      } else {
        alert('Esta função não é suportada por este navegador!');
      }
    },
    returnCSV () {
      this.$emit('loadCSV', { header: this.parse_header, body: this.parse_csv })
    }
  }
}

</script>

<style scoped>

.csvimport {
  border: 1px solid #dfdfdf;
  box-shadow: rgba(0, 0, 0, 0.15) 0 1px 0 0;
}

.panel {
  margin-bottom: 0px;
}

</style>



// WEBPACK FOOTER //
// src/components/common/CSVImport.vue